
import { defineComponent, PropType} from "vue";

export default defineComponent({
  name: "SideBar",
  props: {
    routeKey: { type: String, required: true },
    id: { type: String, required: true },
    item: { type: Object, required: true },
    inputs: { type: Array as PropType<any[]>, required: true },
    
  },
  emits: ["submit", "invalid", "prevent-enter", "update:values", "add-nested-row", "remove-nested-row", "add-tier", "remove-tier"],
  
});
